import { ApiError } from "./response";

export class BaseApiClient {
  protected async fetch(input: RequestInfo, init?: RequestInit): Promise<Response> {
    let response;
    try {
      response = await fetch(input, init);
    } catch (e) {
      throw new ApiError({
        status: 598, // not a real one, so we can recognize it
        message: "Something went wrong in BaseApiClient",
        error: "Something failed in node's fetch method",
        trace: "",
        id: "",
        timestamp: "",
        requestId: ""
      });
    }
    if (!response.ok) {
      if (response.status === 403) {
        throw new ApiError({
          status: response.status,
          message: "Forbidden",
          error: "Forbidden",
          trace: "",
          id: "",
          timestamp: "",
          requestId: ""
        });
      }
      const raw = await response.json();
      raw.status = raw.status ?? response.status;
      raw.message = raw.errorMessage ?? raw.message;
      throw new ApiError(raw);
    }
    return response;
  }

  protected async fetchApi(input: RequestInfo, init?: RequestInit): Promise<Response> {
    return this.fetch(input, {
      ...init,
      headers: {
        "Content-Type": "application/json",
        ...init?.headers
      }
    });
  }
}
